import { QueryClient } from "@tanstack/react-query";

// Axios owns transport retries so errors wrapped by service modules still have
// one retry budget and one terminal Sentry event.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
